import { useRouter } from 'next/router';
import { useAccount } from 'wagmi';

import SearchIcon from '@/assets/icons/icon-search-lg.svg';
import { useAppSelector } from '@/hooks/redux';
import useSearchHandler from '@/hooks/useSearchHandler';
import { useSortRequest } from '@/hooks/useSortRequest';
import { fetchOffersLoans } from '@/redux/loans/loansSlice';
import { cn } from '@/utils/helper';

import BorrowedTab from './my-loans/BorrowedTab';
import LentTab from './my-loans/LentTab';
import LoanRequestsTab from './my-loans/LoanRequestsTab';
import OffersTab from './my-loans/OffersTab';

const tabs = [
  {
    type: 'requests',
    Component: LoanRequestsTab,
  },
  {
    type: 'borrowed',
    Component: BorrowedTab,
  },
  {
    type: 'lent',
    Component: LentTab,
  },
  {
    type: 'offers',
    Component: OffersTab,
  },
  // {
  //   type: 'my pools',
  //   Component: OffersTab,
  // },
];

const MyLoansTable: React.FC = () => {
  const router = useRouter();
  const { address } = useAccount();
  const activeTab = tabs.find(({ type }) => router.query.tab === type) || tabs[0];
  const { offersLoans } = useAppSelector((state) => state.loans);

  const ActiveTab = activeTab.Component;
  const { handleSearch, searchValue } = useSearchHandler();

  useSortRequest(
    (props) => {
      if (!address) return null;

      return fetchOffersLoans({ ...props, address });
    },
    [address]
  );

  return (
    <div className='bg-light-blue-grey dark:!bg-jet-black min-h-full'>
      <div className='lg:pb-5 pt-[27px] bg-white-100 dark:!bg-jet-black'>
        <div className=' flex flex-row bg-white dark:bg-jet-black-100 border h-[50px] rounded-sm w-fit mx-5 sm:mx-6'>
          <div className='relative flex-1 flex items-center w-full max-w-64 h-full bg-white dark:bg-jet-black-100'>
            <SearchIcon className='absolute fill-coal-250 dark:fill-white left-3 top-[calc(50%-10px)]' />
            <input key={router.asPath} defaultValue={searchValue} onChange={handleSearch} placeholder='Search Your Loans' className='pl-[44px] size-full bg-white text-sm font-normal dark:text-white dark:bg-jet-black rounded text-coal-250 focus:text-coal-250' />
          </div>
          <div className='flex-1 flex'>
            {tabs.map((tab) => {
              const { type } = tab;
              const tabWithCounter = type === 'offers' || type === 'requests';
              const offersCounter = offersLoans?.filter((val) => val.loanTokenOwner?.ownerAddress !== address).length;
              const loanRequestCounter = offersLoans?.filter((val) => val.loanTokenOwner?.ownerAddress === address).length;

              return (
                <button
                  onClick={() => {
                    router.push({
                      query: {
                        tab: type,
                      },
                    });
                  }}
                  key={type}
                  className={cn('capitalize h-full px-[25px] w-max flex justify-center border-l items-center gap-[5px]', activeTab.type === type ? '!text-primary-blue-400 dark:!text-primary-blue-100 !bg-primary/15' : ' text-grey-lavender dark:text-white dark:bg-jet-black bg-white')}
                >
                  <span className='text-sm font-normal w-max !text-inherit'>{type}</span>
                  {tabWithCounter && <span className={cn('min-w-[19px] min-h-[19px] px-0.5 pt-0.5  aspect-square rounded-full  flex justify-center items-center text-[10px]/[12px] font-bold text-white bg-forest-green')}>{type === 'offers' ? offersCounter : loanRequestCounter}</span>}
                </button>
              );
            })}
          </div>
        </div>
      </div>
      <div className='overflow-x-auto custom-scrollbar'>
        <ActiveTab />
      </div>
    </div>
  );
};

export default MyLoansTable;
